import React, { useState } from 'react';
import { storage, db } from '../firebase'; // Import your Firebase configuration
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import NavbarAdmin from '../components/NavbarAdmin'; // Import NavbarAdmin

const AddActualite = () => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [photo, setPhoto] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'title') setTitle(value);
    if (name === 'description') setDescription(value);
  };

  const handleFileChange = (e) => {
    setPhoto(e.target.files[0]); // Capture the single file
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUploading(true);
    try {
      let photoUrl = '';

      // Upload photo if selected
      if (photo) {
        const photoRef = ref(storage, `actualites/${photo.name}`);
        await uploadBytes(photoRef, photo);
        photoUrl = await getDownloadURL(photoRef);
      }

      // Add document to Firestore
      await addDoc(collection(db, 'actualites'), {
        title,
        description,
        photo: photoUrl,
        timestamp: Timestamp.now(),
      });

      alert('Actualité ajoutée avec succès !');
      // Reset form
      setTitle('');
      setDescription('');
      setPhoto(null);
    } catch (error) {
      console.error('Erreur lors de l\'ajout du document : ', error);
    } finally {
      setUploading(false);
    }
  };

  const containerStyle = {
    padding: '20px',
    maxWidth: '800px',
    margin: '0 auto',
    fontFamily: 'Arial, sans-serif',
  };

  const headingStyle = {
    fontSize: '2rem',
    color:  '#6699CC',
    fontFamily: 'Chalkboard, Comic Sans MS, cursive, sans-serif',
    margin: '20px 0',
    textAlign: 'center',
    borderBottom: '2px solid #ddd',
    paddingBottom: '10px',
  };

  const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    margin: '0 auto',
    maxWidth: '600px',
  };

  const inputStyle = {
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ddd',
    width: '100%', // Increase width to 100%
    boxSizing: 'border-box', // Ensure padding and border are included in the element's total width
  };

  const textareaStyle = {
    ...inputStyle,
    minHeight: '100px',
  };

  const fileInputStyle = {
    ...inputStyle,
    padding: '8px',
    border: '1px solid #ddd',
    height: 'auto', // Make sure height adapts to content
  };

  const buttonStyle = {
    padding: '10px 20px',
    backgroundColor:  '#6699CC',
    border: 'none',
    borderRadius: '4px',
    color: '#fff',
    fontSize: '1rem',
    cursor: 'pointer',
  };

  const buttonDisabledStyle = {
    ...buttonStyle,
    backgroundColor: '#999',
    cursor: 'not-allowed',
  };

  return (
    <div>
      <NavbarAdmin />
      <div style={containerStyle}>
        <h2 style={headingStyle}>Ajouter une Actualité</h2>
        <form onSubmit={handleSubmit} style={formStyle}>
          <label>
            Titre :
            <input
              type="text"
              name="title"
              value={title}
              onChange={handleInputChange}
              required
              style={inputStyle}
            />
          </label>
          <label>
            Description :
            <textarea
              name="description"
              value={description}
              onChange={handleInputChange}
              required
              style={textareaStyle}
            />
          </label>
          <label>
            Photo :
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              style={fileInputStyle}
            />
          </label>
          <button
            type="submit"
            disabled={uploading}
            style={uploading ? buttonDisabledStyle : buttonStyle}
          >
            {uploading ? 'Téléchargement en cours...' : 'Ajouter l\'Actualité'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddActualite;
